// The funnel's "won" step is the one flagged `completed` (at most one per board), which is
// not necessarily the last column -- a funnel often ends with a "lost" step.
export const findWinStep = steps => (steps || []).find(step => step.completed);

// "Mark as won" only makes sense when the funnel has a won step and the card is not in it yet.
export const canMarkAsWon = (steps, currentStepId) => {
  const winStep = findWinStep(steps);
  return Boolean(winStep) && String(winStep.id) !== String(currentStepId);
};
